import React from 'react';
import { BenefitLabel } from '../common/BenefitLabel';
const LIMIT_DEFAULT = 2;

export function ProductCardRecipeTags({badges, limit = LIMIT_DEFAULT}) {
  if(!badges || (!badges.applications?.length && !badges.other?.length)) { return null; }
  const displayedBadges = [...badges.applications, ...badges.other].slice(0, limit);

  return (
      <div className="pdp__badges-container">
        {displayedBadges.map((badge) => (
          <BenefitLabel key={badge.title} benefit={badge} />
        ))}
      </div>
  );
}
